import React from 'react'

const Donation = () => {
  return (
    <div>
      <h1>This is donation page</h1>
    </div>
  )
}

export default Donation